import { convertShortDayToFull } from "./bidFormUtils";

export function filterBidLines(
  bidLines,
  positionFilters,
  assignmentFilters,
  daysOffFilters,
  startTimesFilters,
  useAssignmentForEmp
) {
  let filteredBidLines = bidLines;
  if (useAssignmentForEmp) {
    filteredBidLines = filterOnAssignments(filteredBidLines, assignmentFilters);
  } else {
    filteredBidLines = filterOnPositions(filteredBidLines, positionFilters);
  }
  filteredBidLines = filterOnDaysOff(filteredBidLines, daysOffFilters);
  filteredBidLines = filterOnStartTimes(filteredBidLines, startTimesFilters);
  return filteredBidLines;
}

export function getDisplayedBidLinesWithRadioFilter(currBidLines, selectedChoices, selectedRadioButton) {
  let displayedBidLines = currBidLines;

  if (selectedRadioButton === "showAll") {
    displayedBidLines = currBidLines;
  } else if (selectedRadioButton === "myChoices") {
    displayedBidLines = applyMyChoicesRadioFilter(currBidLines, selectedChoices);
  } else if (selectedRadioButton === "unselected") {
    displayedBidLines = applyUnselectedRadioFilter(currBidLines, selectedChoices);
  }

  return displayedBidLines;
}

function applyMyChoicesRadioFilter(currentBidLines, selectedChoices) {
  const selectedChoicesArray = selectedChoices;
  return currentBidLines.filter((obj) => selectedChoicesArray.some((element) => obj.id === element));
}

function applyUnselectedRadioFilter(currentBidLines, selectedChoices) {
  const selectedChoicesArray = selectedChoices;
  return currentBidLines.filter((obj) => !selectedChoicesArray.includes(obj.id));
}

export function filterOnPositions(filterBidLines, positionFilters) {
  return filterBidLines.filter((bidLine) => bidLine.shifts.some((shift) => positionFilters.includes(shift.position)));
}

export function filterOnAssignments(filterBidLines, assignmentFilters) {
  return filterBidLines.filter((bidLine) =>
    bidLine.shifts.some((shift) => assignmentFilters.includes(shift.assignment))
  );
}

export function filterOnDaysOff(filterBidLines, daysOffFilters) {
  return filterBidLines.filter((bidLine) => {
    const shiftDaysOff = bidLine.shifts.filter((shift) => shift.isOff).map((shift) => shift.day);
    for (const daysOff of daysOffFilters) {
      const days = daysOff.split("/").map((dayOff) => convertShortDayToFull(dayOff));
      const result = doesDaysOffMatch(shiftDaysOff, days);
      if (result) {
        return true;
      }
    }
    return false;
  });
}

export function filterOnStartTimes(filterBidLines, startTimesFilters) {
  return filterBidLines.filter((bidLine) => {
    return bidLineContainsStartTime(bidLine, startTimesFilters);
  });
}

function doesDaysOffMatch(shiftDaysOff, daysOff) {
  const sortedShiftDaysOff = shiftDaysOff.slice().sort();
  const sortedDaysOff = daysOff.slice().sort();
  for (const element of sortedDaysOff) {
    if (!sortedShiftDaysOff.includes(element)) {
      return false;
    }
  }
  return true;
}

function bidLineContainsStartTime(bidLine, startTimesFilters) {
  for (const shift of bidLine.shifts) {
    if (shift.start && doesBidLineHaveSameStartTime(shift.start, startTimesFilters)) {
      return true;
    }
  }
  return false;
}

function doesBidLineHaveSameStartTime(shiftStartTime, startTimes) {
  for (const startTime of startTimes) {
    if (shiftStartTime === startTime) {
      return true;
    }
  }
  return false;
}
